module.exports = __webpack_public_path__ + "static/presencial-901fb6872ec711657b1a6ab1e94fda8f.jpg";